const dateComparator = function (date1, date2) {
  let date1Number = monthToComparableNumber(date1)
  let date2Number = monthToComparableNumber(date2)
    
  if (date1Number === null && date2Number === null) {
    return 0
  }
  if (date1Number === null) {
    return -1
  }
  if (date2Number === null) {
    return 1
  }
    
  return date1Number - date2Number
}
      
const applyRowsSorting = function (columns) {
  for (const column of columns) {
    if (!column.field) {
      continue
    }
    
    if (column.field.includes('date')) {
      column.comparator = dateComparator
    }
  }
      
  return columns
}
      
const agGridRowsSorting = {
  applyRowsSorting
}
      
export default agGridRowsSorting
    
function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null
  }
      
  let yearNumber = date.substring(6, 10)
  let monthNumber = date.substring(3, 5)
  let dayNumber = date.substring(0, 2)
      
  let result = yearNumber * 10000 + monthNumber * 100 + dayNumber
  return result
}